import { UnitTypes } from 'src/Libs/types'

/**
 * Returns a normalization rule for a given currency, defining how to convert its main unit
 * into a smaller subunit (e.g. euros → cents).
 *
 * The returned object contains:
 *  - multiplier: numeric factor to multiply prices by before numeric calculations (e.g. 100 for EUR → cents)
 *  - subunit: corresponding unit type used for formatting and display
 *
 * This allows pre-normalizing monetary values before computing chart ticks,
 * ensuring consistent math while keeping display logic currency-aware.
 *
 * Additional currencies can be added here if it makes sense to display their subunit, e.g. USD -> US cents
 */
const subunitMap: Record<string, { multiplier: number; subunit: UnitTypes }> = {
  EUR: {
    multiplier: 100,
    subunit: UnitTypes.cents,
  },
}

export const getSubunitOfCurrency = (currencyCode: string): { multiplier: number; subunit: UnitTypes | undefined } => {
  return {
    multiplier: subunitMap[currencyCode]?.multiplier || 1,
    subunit: subunitMap[currencyCode]?.subunit,
  }
}
